import React from 'react';

export function ProcessBar(props) {
  const { em, app } = props;
  const color = (em && em.color) || 'info';
  const value = (em && em.value) || 50;

  const barProperty = {};
  if (em && em.id) barProperty.id = em.id;
  if (props.id) barProperty.id = props.id;

  let show = '';
  if (em && em.showBy && app[em.showBy] === false) show = 'd-none';

  return (
    <div className={`progress ${show} ` + props.className} {...barProperty}>
      <div
        className={`progress-bar progress-bar-striped bg-${color} progress-bar-animated`}
        role="progressbar"
        style={{ width: `${value}%` }}
        aria-valuenow={value}
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  );
}
